import { render, staticRenderFns } from "./FolderCreate.html?vue&type=template&id=174dd757&scoped=true&"
import script from "./FolderCreate.js?vue&type=script&lang=js&"
export * from "./FolderCreate.js?vue&type=script&lang=js&"
import style0 from "./FolderCreate.scss?vue&type=style&index=0&id=174dd757&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174dd757",
  null
  
)

export default component.exports